const LAST_RELOAD_KEY = 'nickel:staleChunkReloadAt'
const RELOAD_COOLDOWN_MS = 60_000

let optionalChunksLoading = 0

function claimReload(): boolean {
  try {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY))
    if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return false
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()))
    return true
  } catch {
    return false
  }
}

/**
 * Loads a chunk the page works without, so that its failure rejects instead of
 * reloading the page over whatever the user has typed. Vite's event does not
 * name the failed chunk in every browser, so a page chunk that fails while this
 * is in flight is left to its error boundary too.
 */
export async function loadOptionalChunk<Module>(
  load: () => Promise<Module>,
): Promise<Module> {
  optionalChunksLoading += 1
  try {
    return await load()
  } finally {
    optionalChunksLoading -= 1
  }
}

// A tab left open across a deploy asks for chunks the new deploy no longer serves,
// which Vite reports as vite:preloadError: https://vite.dev/guide/build#load-error-handling
export function reloadOnStaleChunk(reload = () => window.location.reload()) {
  window.addEventListener('vite:preloadError', (event) => {
    if (optionalChunksLoading > 0) return
    if (!navigator.onLine || !claimReload()) return
    event.preventDefault()
    reload()
  })
}
